import React, { useEffect, useState } from 'react'
import * as api from '../api/api'
import { IconBriefcase, IconGraduationCap } from './Icons'

const ResumeArea = ({ services: propServices }) => {
    const [services, setServices] = useState([]);

    useEffect(() => {
        if (propServices && propServices.length > 0) {
            setServices(propServices);
            return;
        }

        const getServices = async () => {
            try {
                const { data } = await api.fetchServices();
                setServices(data);
            } catch (error) {
                console.error('Error fetching services:', error);
            }
        };
        getServices();
    }, [propServices]);

    return (
        <div>
            <section id="resume" className="resume-area pt-25 pb-20 rel z-1">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row">
                                <div className="col-xl-8 col-lg-9">
                                    <div className="section-title mb-25 wow fadeInUp delay-0-2s">
                                        <span className="sub-title mb-5" style={{ color: '#38BDF8', fontWeight: 600 }}>Work & Education</span>
                                        <h2 style={{ color: '#F8FAFC', fontWeight: 800 }}>Engineering <span>Experience & Qualification</span></h2>
                                    </div>
                                </div>
                            </div>
                            <div className="resume-items-wrap">
                                <div className="row justify-content-between g-2">
                                    <div className="col-xl-6 col-md-6">
                                        <div className="resume-item executive-card wow fadeInUp delay-0-3s p-3 d-flex align-items-start" style={{ marginBottom: '8px' }}>
                                            <div className="icon mt-1" style={{ color: '#38BDF8' }}>
                                                <IconBriefcase size={20} color="#38BDF8" />
                                            </div>
                                            <div className="content ms-3">
                                                <span className="years" style={{ color: '#38BDF8', fontWeight: 700, fontSize: '13px' }}>2026 - Present</span>
                                                <h4 style={{ color: '#F8FAFC', fontSize: '16px', fontWeight: 700 }} className="my-0">Senior Full-Stack Software Engineer</h4>
                                                <span className="company" style={{ color: '#94A3B8', fontSize: '13px' }}>Creative Encode Pvt Ltd, Ahmedabad</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-md-6">
                                        <div className="resume-item executive-card wow fadeInUp delay-0-4s p-3 d-flex align-items-start" style={{ marginBottom: '8px' }}>
                                            <div className="icon mt-1" style={{ color: '#38BDF8' }}>
                                                <IconBriefcase size={20} color="#38BDF8" />
                                            </div>
                                            <div className="content ms-3">
                                                <span className="years" style={{ color: '#38BDF8', fontWeight: 700, fontSize: '13px' }}>2024 - 2025</span>
                                                <h4 style={{ color: '#F8FAFC', fontSize: '16px', fontWeight: 700 }} className="my-0">Full-Stack Software Engineer</h4>
                                                <span className="company" style={{ color: '#94A3B8', fontSize: '13px' }}>Madhav Technology, Surat</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-md-6">
                                        <div className="resume-item executive-card wow fadeInUp delay-0-2s p-3 d-flex align-items-start" style={{ marginBottom: '8px' }}>
                                            <div className="icon mt-1" style={{ color: '#38BDF8' }}>
                                                <IconBriefcase size={20} color="#38BDF8" />
                                            </div>
                                            <div className="content ms-3">
                                                <span className="years" style={{ color: '#38BDF8', fontWeight: 700, fontSize: '13px' }}>2023 - 2024</span>
                                                <h4 style={{ color: '#F8FAFC', fontSize: '16px', fontWeight: 700 }} className="my-0">Senior MERN Stack Developer</h4>
                                                <span className="company" style={{ color: '#94A3B8', fontSize: '13px' }}>VPN INFOTECH INNOVATION</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-md-6">
                                        <div className="resume-item executive-card wow fadeInUp delay-0-2s p-3 d-flex align-items-start" style={{ marginBottom: '8px' }}>
                                            <div className="icon mt-1" style={{ color: '#38BDF8' }}>
                                                <IconBriefcase size={20} color="#38BDF8" />
                                            </div>
                                            <div className="content ms-3">
                                                <span className="years" style={{ color: '#38BDF8', fontWeight: 700, fontSize: '13px' }}>2021 - 2022</span>
                                                <h4 style={{ color: '#F8FAFC', fontSize: '16px', fontWeight: 700 }} className="my-0">MERN Stack Developer</h4>
                                                <span className="company" style={{ color: '#94A3B8', fontSize: '13px' }}>OM TECH WEB SOLUTION, Surat</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-md-6">
                                        <div className="resume-item executive-card wow fadeInUp delay-0-2s p-3 d-flex align-items-start" style={{ marginBottom: '8px' }}>
                                            <div className="icon mt-1" style={{ color: '#38BDF8' }}>
                                                <IconBriefcase size={20} color="#38BDF8" />
                                            </div>
                                            <div className="content ms-3">
                                                <span className="years" style={{ color: '#38BDF8', fontWeight: 700, fontSize: '13px' }}>2020 - 2021</span>
                                                <h4 style={{ color: '#F8FAFC', fontSize: '16px', fontWeight: 700 }} className="my-0">React Developer</h4>
                                                <span className="company" style={{ color: '#94A3B8', fontSize: '13px' }}>SOFT THE NEXT</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-md-6">
                                        <div className="resume-item executive-card wow fadeInUp delay-0-4s p-3 d-flex align-items-start" style={{ marginBottom: '8px' }}>
                                            <div className="icon mt-1" style={{ color: '#38BDF8' }}>
                                                <IconGraduationCap size={22} color="#38BDF8" />
                                            </div>
                                            <div className="content ms-3">
                                                <span className="years" style={{ color: '#38BDF8', fontWeight: 700, fontSize: '13px' }}>2017 - 2020</span>
                                                <h4 style={{ color: '#F8FAFC', fontSize: '16px', fontWeight: 700 }} className="my-0">Bachelor of Engineering (B.E. Computer Engineering)</h4>
                                                <span className="company" style={{ color: '#94A3B8', fontSize: '13px' }}>North Maharashtra University (NMU)</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="services" className="services-area pt-25 pb-25 rel z-1">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-6 col-lg-8">
                            <div className="section-title text-center mb-30 wow fadeInUp delay-0-2s">
                                <span className="sub-title mb-5" style={{ color: '#38BDF8', fontWeight: 600 }}>Core Offerings</span>
                                <h2 style={{ color: '#F8FAFC', fontWeight: 800 }}>Specialized <span>Engineering Services</span></h2>
                            </div>
                        </div>
                    </div>
                    <div className="row g-3">
                        {services.map((service, index) => (
                            <div className="col-lg-6" key={service._id}>
                                <div className={`service-item executive-card p-3 wow fadeInUp delay-0-${(index % 2 + 1) * 2}s`}>
                                    <div className="number" style={{ color: '#38BDF8', fontWeight: 800, fontSize: '24px' }}>{String(index + 1).padStart(2, '0')}.</div>
                                    <div className="content ms-3">
                                        <h4 style={{ color: '#F8FAFC', fontSize: '18px', fontWeight: 700 }} className="mb-1">{service.title}</h4>
                                        <p style={{ color: '#94A3B8', fontSize: '14px', lineHeight: '1.5', margin: 0 }}>{service.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    )
}

export default ResumeArea